export const basisLabel = (b) => (b === "per_night" ? "/night" : b === "one_off" ? "" : "pp");

export const unitCount = (basis, qty, guests, nights, maxGuests) => {
  if (basis === "per_guest") {
    const g = maxGuests ? Math.min(Number(guests) || 1, maxGuests) : (Number(guests) || 1);
    return qty * Math.max(1, g);
  }
  if (basis === "per_night") return qty * Math.max(1, Number(nights) || 1);
  return qty;
};
